
import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useToast } from '@/hooks/use-toast';
import { useDashboard } from '@/hooks/useDashboard';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import DashboardContent from '@/components/dashboard/DashboardContent';
import AccountSettingsDialog from '@/components/dialog/AccountSettingsDialog';

const Dashboard: React.FC = () => {
  const { toast } = useToast();
  const {
    isLoading,
    userData,
    userStatus,
    isAdmin,
    refreshUserStatus
  } = useDashboard();

  // Poll for status changes every 30 seconds as a fallback mechanism
  useEffect(() => {
    console.log('Setting up status polling interval');
    const statusInterval = setInterval(() => {
      console.log('Polling for status changes...');
      refreshUserStatus();
    }, 30000);
    
    return () => clearInterval(statusInterval);
  }, [refreshUserStatus]);
  
  // Refresh status on initial load
  useEffect(() => {
    console.log('Dashboard mounted, refreshing user status');
    refreshUserStatus();
  }, [refreshUserStatus]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <DashboardHeader userName={userData?.full_name} />
      <Navbar />
      
      <section className="py-8 md:py-12 bg-white">
        <div className="container-wide max-w-4xl mx-auto">
          <h1 className="text-2xl font-bold text-itmgmt-dark-blue mb-6">Your Dashboard</h1>
          
          <DashboardContent 
            userStatus={userStatus} 
            isAdmin={isAdmin}
            userData={userData}
          />
        </div>
      </section>

      {/* Account Settings Dialog */}
      <AccountSettingsDialog />
      
      <Footer />
    </div>
  );
};

export default Dashboard;
